import { useForm } from 'react-hook-form';

import { userReset } from '../../../services/Users';
import { useAppContext } from '../../../contexts/app';
import { normalizeEmailFromData } from '../../../utils/validator';

const useForgotPassword = (closeModal) => {
  const { blockScreen, handleAlert } = useAppContext();

  const formMethods = useForm({
    defaultValues: {
      email: '',
    },
  });

  const handleConfirm = (data) => {
    blockScreen(true);

    const postData = normalizeEmailFromData(data);

    Promise.all([userReset(postData)]).then(() => {
      formMethods.reset();
      handleAlert('Help is on the way, please check your email for further instructions.', 'success', 'Reset link sent!');
      closeModal();
      blockScreen(false);
    }).catch((error) => {
      handleAlert(error, 'error');
      blockScreen(false);
    });
  };

  return {
    formMethods,
    handleConfirm,
  };
};

export default useForgotPassword;
